import { render, staticRenderFns } from "./InputContact.vue?vue&type=template&id=47407d5e&scoped=true&"
import script from "./InputContact.vue?vue&type=script&lang=ts&"
export * from "./InputContact.vue?vue&type=script&lang=ts&"
import style0 from "./InputContact.vue?vue&type=style&index=0&id=47407d5e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47407d5e",
  null
  
)

export default component.exports